class BxfTextInputConstants {
    static COMPONENT_NAME = 'bxf-text-input';
    static STRING = {
        PASSWORD: 'password',
        NUMBER: 'number',
        TEXT: 'text',
        DISABLE_ICON: 'disable-icon',
        SIZE: 'regular',
        SMALL: 'small',
        LARGE: 'large',
        LEFT_LABEL: 'bxf-text-input__label--left',
        LEFT_LABEL_VALIDATION_MESSAGE: 'bxf-text-input__label--left-val-message',
        LEFT_LABEL_VALIDATION_MESSAGE_SMALL: 'bxf-text-input__label--left-val-message--small',
        LEFT_LABEL_VALIDATION_MESSAGE_LARGE: 'bxf-text-input__label--left-val-message--large',
        LEFT_LABEL_INSTRUCTIONAL_MESSAGE_SMALL: 'bxf-text-input__label--left-instructional-message-small',
        LEFT_LABEL_INSTRUCTIONAL_MESSAGE_LARGE: 'bxf-text-input__label--left-instructional-message-large',
        COMPACT_THEME: 'bxf-text-input--compact',
        LARGE_THEME: 'bxf-text-input--large',
        DISABLED_LABEL: 'bxf-text-input__label--disabled',
        HIDDEN_LABEL: 'bxf-text-input__label--hidden',
        DISABLED_INPUT: 'bxf-text-input--disabled',
        READONLY_INPUT: 'bxf-text-input--readonly',
        TEXT_INPUT_LABEL: 'bxf-text-input__label',
        TEXT_INPUT_LABEL_SMALL: 'bxf-text-input__label--small',
        TEXT_INPUT_LABEL_LARGE: 'bxf-text-input__label--large',
        TEXT_INPUT_LABEL_COMPACT: 'bxf-text-input__label--compact',
        TEXT_INPUT_LABEL_WRAPPER: 'bxf-text-input-wrapper__label',
        TEXT_INPUT_LABEL_WRAPPER_LEFT: 'bxf-text-input-wrapper__label--left',
        TEXT_INPUT_LABEL_WRAPPER_LEFT_ERROR: 'bxf-text-input-wrapper__label--left-error',
        TEXT_INPUT_LABEL_WRAPPER_LEFT_COMPACT: 'bxf-text-input-wrapper__label--left-compact',
        TEXT_INPUT: 'bxf-text-input',
        TEXT_INPUT_INPUT_BOX: 'bxf-text-input__input',
        TEXT_INPUT_CAPITALIZE: 'bxf-text-input__text--capitalize',
        TEXT_INPUT_SHOW_PLACEHOLDER: 'bxf-text-input__input--show-placeholder',
        TEXT_INPUT_NO_ITALIC: 'bxf-text-input__input--no-italic',
        TEXT_INPUT_FOCUSED: 'bxf-text-input--focused',
        TEXT_INPUT_KEY_FOCUSED: 'bxf-text-input--focused-keyboard',
        TEXT_INPUT_ICON: 'bxf-text-input__icon',
        TEXT_INPUT_CONTAINER: 'bxf-text-input__container',
        TEXT_INPUT_ERROR: 'bxf-text-input--error',
        TEXT_INPUT_WARNING: 'bxf-text-input--warning',
        TEXT_INPUT_SUCCESS: 'bxf-text-input--success',
        INPUT_ICON_WRAPPER: 'bxf-text-input-wrapper__text-icon',
        ERROR_MESSAGE: 'bxf-text-input__message--error',
        WARNING_MESSAGE: 'bxf-text-input__message--warning',
        SUCCESS_MESSAGE: 'bxf-text-input__message--success',
        TEXT_INPUT_REQUIRED: 'bxf-text-input__label--required',
        TEXT_INPUT_REQUIRED_TOP: 'bxf-text-input__label--required-top',
        TEXT_INPUT_REQUIRED_SMALL: 'bxf-text-input__label--required--small',
        TEXT_INPUT_REQUIRED_LARGE: 'bxf-text-input__label--required--large',
        TEXT_INPUT_WRAPPER_ERROR: 'bxf-text-input-wrapper--error',
        TEXT_INPUT_COUNTER_CONTAINER_LEFT: 'bxf-text-input__counter-container--left',
        CHARACTER_COUNTER: 'bxf-text-input__character-counter',
        CHARACTER_COUNTER_INSTRUCTIONAL: 'bxf-text-input__character-counter--instructional',
        APPEND: 'bxf-text-input__append',
        PREPEND: 'bxf-text-input__prepend',
        CLEAR_ICON: 'bxf-clear-icon',
        CLEAR_ICON_LARGE: 'bxf-clear-icon-large',
        CLEAR_ICON_HIDDEN: 'bxf-clear-icon--hidden',
        CLEAR_BUTTON_DISABLED: 'bxf-clear-icon--disabled',
        INPUT_CLEAR_CONTAINER: 'bxf-clear-icon__container',
        CLEAR_ICON_ID: 'bxf-clear-icon-id',
        CLEAR_BUTTON_LABEL: 'Clear',
        DISABLED: 'disabled',
        FOCUSED: 'focused',
        POPULATED: 'populated',
        LEFT: 'left',
        TEXT_INPUT_INNER_SECTION: 'bxf-text-input__inner-section',
        INPUT_BXF_ID: 'bxf-text-input-input-element',
        REMOVE_PADDING: 'bxf-text-input--no-padding',
        INSTRUCTIONAL_TEXT: 'bxf-text-input__instructional-text',
        INSTRUCTIONAL_TEXT_COUNTER: 'bxf-text-input__instructional-text--counter',
        INPUT_BOX: 'bxf-text-input__box',
    };
    static EVENTS = {
        VALUE_CHANGED: 'valueChanged',
    };
}

export { BxfTextInputConstants as B };
